/** The booking page the landing site uses for "Book a call". */
export const BOOK_A_CALL_URL = 'https://cal.com/admin-console-vr283u/30min';
